"use client";

import { motion, useScroll, useSpring } from "motion/react";

export function ScrollProgress() {
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, {
    stiffness: 120,
    damping: 30,
    restDelta: 0.001,
  });

  return (
    <motion.div
      className="progress-bar pointer-events-none fixed top-0 left-0 z-[70] h-[2px] w-full bg-brass"
      style={{ scaleX }}
    />
  );
}
